import React from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const handleMapClick = () => {
    window.open('https://maps.google.com?q=317-319+Lower+High+St,+Watford,+WD17+2JD', '_blank');
  };

  return (
    <section id="support" className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title">Contact Us</h2>
        <div className="contact-stack">
          <div className="contact-info">
            <h3 className="info-title">Get in Touch</h3>
            <div className="info-item">
              <span>317-319 Lower High St, Watford, WD17 2JD</span>
            </div>
            <div className="info-item">
              <a href="tel:+447432496113">07432 496113</a>
            </div>
            <div className="info-item">
              <a href="mailto:kkptradeltd@gmail.com">kkptradeltd@gmail.com</a>
            </div>
            <div className="map-snap" onClick={handleMapClick}>
              <span className="map-text">View on Map</span>
            </div>
          </div>
          <div className="contact-form">
            <h3 className="form-title">Send a Message</h3>
            <form>
              <div className="form-field">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" placeholder="e.g., Dave the Dealer" required />
              </div>
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" placeholder="e.g., dave@tradeshop.co.uk" required />
              </div>
              <div className="form-field">
                <label htmlFor="message">Message</label>
                <textarea id="message" placeholder="Need a pallet of crisps ASAP..." required />
              </div>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;